const Color = require("color");

export class ColorUtilities {
    static lighten(color: string, amount: number): string {
        return Color(color)
            .lighten(Math.abs(amount - 1))
            .hex();
    }

    static darken(color: string, amount: number): string {
        return Color(color)
            .darken(Math.abs(amount - 1))
            .hex();
    }

    static isLight(color: string): boolean {
        return Color(color).isLight();
    }

    static isDark(color: string): boolean {
        return !this.isLight(color);
    }

    static fade(color: string, amount: number): string {
        return Color(color).fade(amount).rgb().toString();
    }

    static opequer(color: string, amount: number): string {
        return Color(color).opequer(amount).rgb().toString();
    }

    static rgb(color: string): string {
        return Color(color).rgb();
    }
}
